var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('os-datatable',{attrs:{"title":_vm.textHeader,"headers":_vm.headers,"show-search-bar":true},on:{"rowclicked":(e) => _vm.$emit('rowclicked', e),"create":() => _vm.$emit('create')},model:{value:(_vm.campaigns),callback:function ($$v) {_vm.campaigns=$$v},expression:"campaigns"}})
}
var staticRenderFns = []

export { render, staticRenderFns }